import {createSelector} from 'reselect';
import {getFrom} from '../../utils';

export const selectEnumType = (type: string) => createSelector(
    getFrom('textEnums'),
    getFrom(type)
);
